module.exports = __webpack_public_path__ + "static/logo-osc-a23c4fbe776cf7621ff4152b0773f35d.png";